import React from "react";
import dayjs, { Dayjs } from "dayjs";
import { Box, TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { ClassNames } from "@emotion/react";


interface Props {
  label?: string;
  value: Dayjs | null;
  onChange: (date: Dayjs | null) => void;
  disableFuture?: boolean;
  disablePast?: boolean;
  format?: string;
  fullWidth?: boolean;
  error?: boolean;
  helperText?: string;
  className?:string
}

const MuiDatePicker: React.FC<Props> = ({
  label,
  value,
  onChange,
  disableFuture = false,
  disablePast = false,
  fullWidth = true,
  error,
  helperText,
  className
}) => {
  return (
    <>
    <LocalizationProvider dateAdapter={AdapterDayjs}>
    <Box sx={{ display: "flex", width: "741px" }} pb={2}>
        {" "}
        <label className={"selectionlable"}>{label}</label>
      </Box>
    <DatePicker
      // label={label}
      value={value}
      onChange={onChange}
      disableFuture={disableFuture}
      disablePast={disablePast}
      className={className}
      slotProps={{
        textField: {
          fullWidth,
          error,
          helperText,
        } as any, // Cast to `any` to avoid TS errors in some versions
      }}
    />
    </LocalizationProvider>
    </>
  );
};

export default MuiDatePicker;
